// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill' //兼容ie
import Vue from 'vue'
Vue.config.devtools = true
import App from './App'
import router from './router'
import store from './store'
import config from '@config';
import axios from 'axios';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import './assets/iconfont/iconfont.css'

//样式初始化
import './assets/css/init.css'
import './assets/css/common.css'
// import { VueReCaptcha } from 'vue-recaptcha-v3'
const nodeEnv = process.env.NODE_ENV;

let currPath = window.location.href.split('#')[1];
currPath = currPath.split('?')[0];
// if(currPath !='/geneFAQdetail' && currPath !='/geneFAQ'){
//     Vue.use(VueReCaptcha, {
//         siteKey: config[nodeEnv].sitekey,
//         loaderOptions: {
//           useRecaptchaNet: true
//         }
//       })
// }

Vue.use(ElementUI)
Vue.use(iView);
Vue.use({ router: router })


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})






//全局修改axios默认配置
// axios.defaults.baseURL = config[nodeEnv].apiHost;
//axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = "application/json"

const defaultHeaders = {
  Pragma: 'no-cache',
  'Cache-Control': 'no-cache',
}
// 设置默认头
Object.assign(axios.defaults.headers.common, defaultHeaders)

// 添加请求拦截器
axios.interceptors.request.use(config => {

  // 在发送请求之前做些什么
  //判断是否存在token，如果存在将每个页面header都添加token
  if (store.getters.currentUser.token) {//    
    config.headers.common['Authorization'] = 'Bearer ' + store.getters.currentUser.token;
  }

  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.code === 700) {
      store.commit("logout");// 删除已经失效或过期的token（不删除也可以，因为登录后覆盖）
      router.replace({
        path: '/login' // 到登录页重新获取token

      })

    } else if (response.data.code !== 0 && response.data.msg != '' && response.data.code !== 40015 && response.data.code !== 40005 && response.data.code !== 41001&& response.data.code !== 42104) {
      if(response.data.msg){
        ElementUI.Message({
          message: response.data.msg == '参数错误' ? response.data.msg + JSON.stringify(response.data.data) : response.data.msg,
          type: 'error'
        });
      }
      
    } else if (response.data.token) { // 判断token是否存在，如果存在说明需要更新token

      sessionStorage.setItem('token', response.data.token) // 覆盖原来的token(默认一天刷新一次)

    }

    return response;
  },
  error => {

    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (router.currentRoute.path != '/login') {
            store.commit('logout');
          }
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }//登录成功后跳入浏览的当前页面
          })
      }
    }
    return Promise.reject(error)
  });

var instance = axios.create({
  baseURL: config[nodeEnv].apiHost,
  headers: { 
    'Content-Type': 'multipart/form-data',
    'Authorization':'Bearer ' + (!store.getters.currentUser.token?sessionStorage.getItem('token'):store.getters.currentUser.token)
   }
})
Vue.config.productionTip = false;
Vue.prototype.instance = instance;



// WEBPACK FOOTER //
// ./src/main.js